import { FC, useEffect }                      from 'react';
import { useCurrentUser, usePrefStates }      from '../../../../hooks';
import { UserService }                        from '../../../../services/UserService';
import { TimeService }                        from '../../../../services/TimeService';
import { ENVIRONMENT_LABEL, PRODUCT_VERSION } from '../../../../constants/SystemEnums';
import { v5 as uuidv5 }                       from "uuid";

interface IntercomIdentifierProps {
    [ additionalProps: string ]: any
}

const defaultProps: IntercomIdentifierProps = {}

const IntercomIdentifier: FC<IntercomIdentifierProps> = ( props ) => {

    let { currentUser }        = useCurrentUser(),
        [ , prefs, prefEnums ] = usePrefStates();

    useEffect( () => {

        try{
            if( window[ 'Intercom' ] ){

                if( currentUser.id ){

                    let lastKnownProjectId = prefs.get( prefEnums.PROJECT_ID ) ?? null;

                    // namespaced key using domain and user id for unique keys across same accounts but different tenants / domains
                    const uniqueUserId = uuidv5( window.location.hostname, currentUser.id );

                    //@ts-ignore
                    window.Intercom( "update", {
                        email:               UserService.getUserEmail( currentUser ),
                        name:                currentUser.firstName,
                        first_name:          currentUser.firstName,
                        last_name:           currentUser.lastName,
                        user_id:             uniqueUserId,
                        user_account_id:     currentUser.id,
                        created_at:          TimeService.ISOtoFormat( currentUser.createdUtc, 'x' ),
                        tenant:              window.location.hostname,
                        systemRole:          currentUser.systemRole,
                        product_version:     PRODUCT_VERSION,
                        product_environment: ENVIRONMENT_LABEL,
                        project_id:          lastKnownProjectId
                    } );

                } else {
                    console.log( `[Intercom - IDENTIFY]: Anonymous }` );

                    // no user, so no data required...
                    //@ts-ignore
                    window.Intercom( "update" );

                }
            }

        } catch( e ) {

            // swallow error

        }

    } );

    return null;
}

IntercomIdentifier.defaultProps = defaultProps;

export { IntercomIdentifier }
